import { Amount } from "@/components/Product/Amount/amount.component";
import { AmountDropDownComponentProps } from "@/components/Product/Amount/components/amountDropDown.component";
import { AmountInputComponentProps } from "@/components/Product/Amount/components/amountInput.component";

import { useDeliveryContext } from "../../context/delivery.context";

type AmountContainerProps = {
    components?: {
        Input: React.FC<AmountInputComponentProps>;
        DropDown: React.FC<AmountDropDownComponentProps>;
    };
};

const AmountContainer = ({ components }: AmountContainerProps) => {
    const {
        roundingValue,
        activeDelivery,
        activeQuantity,
        isUpdatingCart,
        minimumOrderQuantity,
        changeQuantity
    } = useDeliveryContext();

    return (
        <Amount
            components={components}
            roundingValue={roundingValue}
            activeDelivery={activeDelivery}
            isUpdatingCart={isUpdatingCart}
            minimumOrderQuantity={minimumOrderQuantity}
            value={activeQuantity}
            onQuantityChange={(value) => changeQuantity(value)}
        />
    );
};

export { AmountContainer };
